'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Form = void 0;
var $ = require("jquery");
var Form = /** @class */ (function () {
    function Form() {
        var _this = this;
        this.errorFlag = false;
        this.errorFlagArray = '';
        this.speed = 500;
        $('.trigCheckForm').on('click', function (e) {
            var firstErrorIndex = _this.getFirstErrorIndex();
            //console.log('this.firstErrorIndex', firstErrorIndex);
            if (firstErrorIndex !== -1) {
                // フォーム処理中断
                e.preventDefault();
                // エラーメッセージまでの移動
                _this.scrollErrorMessage(firstErrorIndex);
            }
        });
    }
    // エラーのあった番号を取得
    Form.prototype.getFirstErrorIndex = function () {
        this.errorFlagArray = [];
        // フォームのエラーを配列に入れる
        this.errorFlagArray.push(this.checkName());
        this.errorFlagArray.push(this.checkNameKana());
        this.errorFlagArray.push(this.checkTel());
        this.errorFlagArray.push(this.checkMail());
        this.errorFlagArray.push(this.checkTextarea());
        this.errorFlagArray.push(this.checkAgree());
        return $.inArray(true, this.errorFlagArray);
    };
    // お名前
    Form.prototype.checkName = function () {
        var nameVal = $('input[name="name"]').val();
        if (nameVal !== '') {
            this.errorFlag = false;
            $('.bulletErrorName').text('');
            $('.bulletErrorName').css('display', 'none');
        }
        else {
            this.errorFlag = true;
            $('.bulletErrorName').text('お名前を入力してください。');
            $('.bulletErrorName').css('display', 'block');
        }
        return this.errorFlag;
    };
    // フリガナ
    Form.prototype.checkNameKana = function () {
        var nameKanaVal = $('input[name="name_kana"]').val();
        if (nameKanaVal !== '') {
            if (this.isKana(nameKanaVal)) {
                this.errorFlag = false;
                $('.bulletErrorNameKana').text('');
                $('.bulletErrorNameKana').css('display', 'none');
            }
            else {
                this.errorFlag = true;
                $('.bulletErrorNameKana').text('全角カナで入力してください。');
                $('.bulletErrorNameKana').css('display', 'block');
            }
        }
        else {
            this.errorFlag = true;
            $('.bulletErrorNameKana').text('フリガナを入力してください。');
            $('.bulletErrorNameKana').css('display', 'block');
        }
        return this.errorFlag;
    };
    // TEL
    Form.prototype.checkTel = function () {
        var telVal = $('input[name="tel"]').val();
        if (telVal !== '') {
            if (this.isPhoneNumber(telVal)) {
                this.errorFlag = false;
                $('.bulletErrorTel').html('');
                $('.bulletErrorTel').css('display', 'none');
            }
            else {
                this.errorFlag = true;
                $('.bulletErrorTel').html('番号が正しくありません。<br>例）000-1234-5678');
                $('.bulletErrorTel').css('display', 'block');
            }
        }
        else {
            this.errorFlag = true;
            $('.bulletErrorTel').html('電話番号を入力してください。');
            $('.bulletErrorTel').css('display', 'block');
        }
        return this.errorFlag;
    };
    // メールアドレス
    Form.prototype.checkMail = function () {
        var emailVal = $('input[name="email"]').val();
        if (emailVal !== '') {
            if (this.isAddress(emailVal)) {
                this.errorFlag = false;
                $('.bulletErrorEmail').html('');
                $('.bulletErrorEmail').css('display', 'none');
            }
            else {
                this.errorFlag = true;
                $('.bulletErrorEmail').html('メールアドレスが正しくありません。<br>例）sample@hwc.or.jp');
                $('.bulletErrorEmail').css('display', 'block');
            }
        }
        else {
            this.errorFlag = true;
            $('.bulletErrorEmail').html('メールアドレスを入力してください。');
            $('.bulletErrorEmail').css('display', 'block');
        }
        return this.errorFlag;
    };
    // お問い合わせ内容
    Form.prototype.checkTextarea = function () {
        var textareaVal = $('textarea[name="inquiry"]').val();
        if (textareaVal !== '') {
            this.errorFlag = false;
            $('.bulletErrorInquiry').text('');
            $('.bulletErrorInquiry').css('display', 'none');
        }
        else {
            this.errorFlag = true;
            $('.bulletErrorInquiry').text('お問い合わせ内容を入力してください。');
            $('.bulletErrorInquiry').css('display', 'block');
        }
        return this.errorFlag;
    };
    // 同意
    Form.prototype.checkAgree = function () {
        if ($('input[name="agree"]').prop('checked')) {
            this.errorFlag = false;
            $('.bulletErrorAgree').html('');
            $('.bulletErrorAgree').css('display', 'none');
        }
        else {
            this.errorFlag = true;
            $('.bulletErrorAgree').html('当施設プライバシーポリシーに<br class="not-pc not-tab">同意頂く必要があります。');
            $('.bulletErrorAgree').css('display', 'block');
        }
        return this.errorFlag;
    };
    Form.prototype.isKana = function (str) {
        var regexp = /^[\u{3000}-\u{301C}\u{30A1}-\u{30F6}\u{30FB}-\u{30FE}]+$/mu;
        if (regexp.test(str)) {
            return true;
        }
        else {
            return false;
        }
    };
    Form.prototype.isPhoneNumber = function (phoneNumber) {
        var val = phoneNumber.replace(/[━.*‐.*―.*－.*\-.*ー.*\-]/gi, '');
        if (val.match(/^(0[5-9]0[0-9]{8}|0[1-9][1-9][0-9]{7})$/)) {
            return true;
        }
        else {
            return false;
        }
    };
    Form.prototype.isAddress = function (address) {
        var reg = /^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/;
        if (reg.test(address)) {
            return true;
        }
        else {
            return false;
        }
    };
    // エラーメッセージ箇所までの移動
    Form.prototype.scrollErrorMessage = function (index) {
        var _this = this;
        var bullet = '.bulletScrollError_' + index;
        var position = $(bullet).offset().top;
        setTimeout(function () {
            var headerHeight = $('.paramHeader').outerHeight();
            // 移動実行
            $('html, body').animate({ scrollTop: position - headerHeight }, _this.speed);
        }, 100);
    };
    return Form;
}());
exports.Form = Form;
exports.default = Form;
